import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { CampaignsScreen } from '../features/campaigns/CampaignsScreen';
import { BackLink } from '../components/BackLink';

export const Route = createFileRoute('/tenants_/$tenantId_/campaigns')({
  component: CampaignsPage,
});

function CampaignsPage() {
  const { t } = useTranslation('tenants');
  const { tenantId } = Route.useParams();
  const { data: session } = useSession();

  const canEdit = hasRole(session, PlatformRole.Editor, tenantId);
  const canView = hasRole(session, PlatformRole.Viewer, tenantId);

  return (
    <Stack gap="sm">
      <BackLink to="/tenants/$tenantId" params={{ tenantId }} search={{ tab: 'campaigns' }} />

      {!canView ? (
        <Alert color="red" title={t('noAccessCampaignsTitle')}>
          {t('noRoleBody')}
        </Alert>
      ) : (
        <>
          {!canEdit && (
            <Alert color="blue" variant="light" title={t('readOnlyTitle')}>
              {t('readOnlyCampaignsBody')}
            </Alert>
          )}
          <CampaignsScreen tenantId={tenantId} canEdit={canEdit} />
        </>
      )}
    </Stack>
  );
}
